export interface FleetReportsTableColumn {
  id: string;
  label: string;
  hasSort?: boolean;
}

export const FLEET_REPORTS_COLS: FleetReportsTableColumn[] = [
  { id: "checkbox", label: "", hasSort: false },
  { id: "company", label: "Fleet Vendor", hasSort: true },
  { id: "subtype", label: "Fleet Sub Vendor", hasSort: true },
  { id: "model", label: "Fleet Type", hasSort: true },
  { id: "size", label: "Fleet Size", hasSort: true },
  { id: "van_number", label: "Fleet No.", hasSort: true },
  { id: "plate", label: "Plate", hasSort: true },
  { id: "vin", label: "Vin", hasSort: true },
  { id: "station", label: "Base Station", hasSort: true },
  { id: "status", label: "Status", hasSort: true },
  { id: "onboarded_date", label: "Onboarded Date", hasSort: true },
  { id: "offboarded_date", label: "Offboarded Date", hasSort: true },
  { id: "rate", label: "Montly Rate", hasSort: true },
  { id: "invoice", label: "Invoice Value", hasSort: true },
  { id: "payroll_comment", label: "Comment", hasSort: true },
  { id: "invoice_number", label: "Invoice No.", hasSort: true },
  { id: "invoice_date", label: "Invoice Date", hasSort: true },
  { id: "rental_period", label: "Rental Start", hasSort: true },
  { id: "rental_period_to", label: "Rental End", hasSort: true },
  { id: "paid_amount", label: "Paid Amount", hasSort: true },
  { id: "payment_date", label: "Payment Date", hasSort: true },
  { id: "payment_method", label: "Payment Method", hasSort: true },
  { id: "deductibles_amount", label: "Deductible Amount", hasSort: true },
  { id: "deductibles_invoice_number", label: "Deductible Payment Invoice No.", hasSort: true },
  { id: "deductibles_payment_date", label: "Deductible Payment Date", hasSort: true },
  { id: "deductibles_paid_amount", label: "Deductible Paid Amount", hasSort: true },
  { id: "deductibles_payment_method", label: "Deductible Payment Method", hasSort: true },
];

export const getFleetReportsTableColumns = (
  activeColumns: string[] = [],
  isFixed?: boolean,
  fixedColumns: string[] = [],
) =>
  FLEET_REPORTS_COLS.filter((col) => {
    if (col.id === "checkbox") return !!isFixed;
    if (!activeColumns.includes(col.id)) return false;
    const isPinned = fixedColumns.includes(col.id);
    return isFixed ? isPinned : !isPinned;
  });

export const FLEET_REPORTS_TABLE_HADER_FILTER_COLUMNS = [
  {
    id: "fleet-information",
    name: "Fleet Information",
    subList: [
      { paths: ["company"], name: "Fleet Vendor" },
      { paths: ["subtype"], name: "Fleet Sub Vendor" },
      { paths: ["model"], name: "Fleet Type" },
      { paths: ["size"], name: "Fleet Size" },
      { paths: ["van_number"], name: "Fleet No." },
      { paths: ["plate"], name: "Plate" },
      { paths: ["vin"], name: "Vin" },
      { paths: ["station"], name: "Base Station" },
      { paths: ["status"], name: "Status" },
      { paths: ["onboarded_date"], name: "Onboarded Date" },
      { paths: ["offboarded_date"], name: "Offboarded Date" },
    ],
  },
  {
    id: "invoice-information",
    name: "Invoice Information",
    subList: [
      { paths: ["rate"], name: "Montly Rate"},
      { paths: ["invoice"], name: "Invoice Value"},
      { paths: ["payroll_comment"], name: "Comment"},
      { paths: ["invoice_number"], name: "Invoice No."},
      { paths: ["invoice_date"], name: "Invoice Date"},
      { paths: ["rental_period"], name: "Rental Start"},
      { paths: ["rental_period_to"], name: "Rental End"},
    ],
  },
  {
    id: "payment-information",
    name: "Payment Information",
    subList: [
      { paths: ["paid_amount"], name: "Paid Amount" },
      { paths: ["payment_date"], name: "Payment Date" },
      { paths: ["payment_method"], name: "Payment Method" },
    ],
  },
  {
    id: "deductible-information",
    name: "Deductible Information",
    subList: [
      { paths: ["deductibles_amount"], name: "Deductible Invoice No." },
      { paths: ["deductibles_invoice_number"], name: "Deductible Payment Date" },
      { paths: ["deductibles_payment_date"], name: "Deductible Payment Date" },
      { paths: ["deductibles_paid_amount"], name: "Deductible Paid Amount" },
      { paths: ["deductibles_payment_method"], name: "Deductible Payment Method" },
    ],
  },
];
